export const api_url = "https://demo.firststepacademy.online/api/v1/";
// export const api_url = "https://myschool.firststepacademy.online/api/v1/";
